export default __webpack_public_path__ + "static/meshery-playground-alt-3-d3a33876a49f9ee3650ceebe578b2846.webp";